import {
  SET_REMINDERS,
  SET_SHOW_PANEL,
  SET_PICKER_OPEN
} from '@/constants/mutationTypes'

const state = {
  reminders: [],
  isShowPanel: '',
  isPickerOpen: false
}
const getters = {
  reminders: state => state.reminders,
  isShowPanel: state => state.isShowPanel,
  isPickerOpen: state => state.isPickerOpen
}
const actions = {
  setReminders ({commit}, data) {
    commit(SET_REMINDERS, {data})
  },
  setShowPanel ({commit}, data) {
    commit(SET_SHOW_PANEL, {data})
  },
  setPickerOpen ({commit}, data) {
    commit(SET_PICKER_OPEN, {data})
  }
}
const mutations = {
  [SET_REMINDERS] (state, {data}) {
    state.reminders = data
  },
  [SET_SHOW_PANEL] (state, {data}) {
    state.isShowPanel = data
  },
  [SET_PICKER_OPEN] (state, {data}) {
    state.isPickerOpen = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Reminders/modules/store.js